exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3PiJ2WyNY99H0v{background:#ebecf0}", ""]);

// exports
exports.locals = {
	"popover": "_3PiJ2WyNY99H0v"
};